import {
  AppHeader,
  AppSidebar,
  SidebarInset,
  SidebarProvider,
} from "@/components";
import { useAuthStore } from "@/store";
import { Outlet } from "react-router-dom";

const AppLayout = () => {
  // TODO: Replace with actual notification count from API/store
  const notificationCount = 3;

  const user = useAuthStore((state) => state.user);
  
  const userName = user?.name || user?.first_name || "Super Admin";
  const userEmail = user?.org_email || user?.personal_email || user?.email || "admin@college.edu";

  const handleSearch = (query: string) => {
    // TODO: Implement global search functionality
    console.log("Global search:", query);
  };

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="h-screen overflow-hidden">
        <AppHeader
          onSearch={handleSearch}
          notificationCount={notificationCount}
          userName={userName}
          userEmail={userEmail}
        />
        <main className="scrollbar-thin min-h-0 flex-1 overflow-auto p-4">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default AppLayout;
